import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { LISP_SUGGESTION_HOVER_SPECULATION_SHORT_THRESHOLD } from "@faire/web-api--source/indigofair/settings/LISP_SUGGESTION_HOVER_SPECULATION_SHORT_THRESHOLD";
import { LISP_SUGGESTION_HOVER_SPECULATION_THRESHOLD } from "@faire/web-api--source/indigofair/settings/LISP_SUGGESTION_HOVER_SPECULATION_THRESHOLD";
export var useSettingLISPHoverThreshold = function() {
    return useSetting(LISP_SUGGESTION_HOVER_SPECULATION_THRESHOLD, 300);
};
export var useSettingLISPShortHoverThreshold = function() {
    return useSetting(LISP_SUGGESTION_HOVER_SPECULATION_SHORT_THRESHOLD, 100);
};
